import actors from './actors'
import frequencies from './frequencies'
import invoiceStates from './invoice-states'
import paymentsStates from './payments-states'
import persons from './persons'
import periods from './periods'
import salesStates from './sales-states'
import subscriptionStates from './subscriptions-states'
import typesOfSale from './types-of-sale'

const parameters = {
  actors: [...actors],
  frequencies: [...frequencies],
  invoiceStates: [...invoiceStates],
  paymentsStates: [...paymentsStates],
  periods: [...periods],
  persons: [...persons],
  salesStates: [...salesStates],
  subscriptionStates: [...subscriptionStates],
  typesOfSales: [...typesOfSale]
}

export default parameters
